import { Table } from '@iveco-ti/iveco-ds'

import { GenericContentModel } from '@/common/models/genericContent'
import { GenericContentActiveActions } from './GenericContentActiveActions'
import { GenericContentInactiveActions } from './GenericContentInactiveActions'

type GenericContentTableRowProps = {
  genericContent: GenericContentModel
}

export function GenericContentTableRow({
  genericContent,
}: GenericContentTableRowProps) {
  return (
    <Table.Row hideCheckbox id={genericContent?.id}>
      <Table.Data className="flex flex-col justify-center">
        <span className="text-base-800 font-semibold text-sm">
          {genericContent?.tagContent}
        </span>
      </Table.Data>

      <Table.Data className="flex flex-col justify-center">
        <span className="text-base-800 font-semibold text-sm">
          {genericContent?.fieldKey}
        </span>
        <span className="text-base-600 font-light text-sm">
          {genericContent?.infoMessage}
        </span>
      </Table.Data>

      <Table.Data className="flex flex-col justify-center">
        <span className="text-base-800 font-normal text-sm">
          {genericContent?.fieldValue}
        </span>
      </Table.Data>

      <Table.Data end>
        {genericContent.isActive && (
          <GenericContentActiveActions genericContent={genericContent} />
        )}
        {!genericContent.isActive && (
          <GenericContentInactiveActions genericContent={genericContent} />
        )}
      </Table.Data>
    </Table.Row>
  )
}
